(() => {
  const SELECTOR =
    '.fokus-benefit-rail:not([data-benefit-autoplay-ready])';

  function initializeFokusBenefitRails() {
    document.querySelectorAll(SELECTOR).forEach((rail) => {
      rail.dataset.benefitAutoplayReady = 'true';

      const track = rail.querySelector(
        '.fokus-benefit-rail__list'
      );

      const items = Array.from(
        rail.querySelectorAll(
          '.fokus-benefit-rail__item'
        )
      );

      if (!track || items.length < 2) return;

      const mobileQuery = window.matchMedia(
        '(max-width: 749px)'
      );

      const reducedMotionQuery = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      );

      let currentIndex = 0;
      let autoplayTimer = null;
      let resumeTimer = null;
      let isVisible = true;
      let isInteracting = false;

      const autoplayDelay = 4000;
      const interactionDelay = 6000;

      function getClosestIndex() {
        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const distance = Math.abs(
            track.scrollLeft - item.offsetLeft
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function goToItem(index, smooth = true) {
        if (!mobileQuery.matches) return;

        currentIndex =
          (index + items.length) % items.length;

        track.scrollTo({
          left: items[currentIndex].offsetLeft,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }

      function stopAutoplay() {
        if (!autoplayTimer) return;

        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function canAutoplay() {
        return (
          mobileQuery.matches &&
          !reducedMotionQuery.matches &&
          !document.hidden &&
          isVisible &&
          !isInteracting
        );
      }

      function startAutoplay() {
        stopAutoplay();

        if (!canAutoplay()) return;

        autoplayTimer = window.setInterval(() => {
          goToItem(currentIndex + 1);
        }, autoplayDelay);
      }

      function resumeAfterInteraction() {
        stopAutoplay();

        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
        }

        resumeTimer = window.setTimeout(() => {
          currentIndex = getClosestIndex();
          isInteracting = false;
          startAutoplay();
        }, interactionDelay);
      }

      track.addEventListener(
        'pointerdown',
        () => {
          isInteracting = true;
          stopAutoplay();
        },
        { passive: true }
      );

      track.addEventListener(
        'pointerup',
        () => {
          window.setTimeout(() => {
            currentIndex = getClosestIndex();
            resumeAfterInteraction();
          }, 200);
        },
        { passive: true }
      );

      track.addEventListener(
        'pointercancel',
        () => {
          currentIndex = getClosestIndex();
          resumeAfterInteraction();
        },
        { passive: true }
      );

      track.addEventListener(
        'scroll',
        () => {
          if (isInteracting) {
            currentIndex = getClosestIndex();
          }
        },
        { passive: true }
      );

      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        }
      );

      const observer = new IntersectionObserver(
        (entries) => {
          isVisible = entries[0]?.isIntersecting ?? false;

          if (isVisible) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        },
        {
          threshold: 0.3
        }
      );

      observer.observe(rail);

      function handleViewportChange() {
        if (!mobileQuery.matches) {
          stopAutoplay();
          currentIndex = 0;

          track.scrollTo({
            left: 0,
            behavior: 'auto'
          });

          return;
        }

        startAutoplay();
      }

      mobileQuery.addEventListener?.(
        'change',
        handleViewportChange
      );

      reducedMotionQuery.addEventListener?.(
        'change',
        handleViewportChange
      );

      startAutoplay();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeFokusBenefitRails
    );
  } else {
    initializeFokusBenefitRails();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeFokusBenefitRails
  );
})();